import { makeStyles } from '@material-ui/styles';
import theme from '../theme';
import { useTranslation } from 'tools/i18n';
import AccountIcon from '../../public/images/icons/my-newport.svg';
import NewportDrawer from '../drawer';
import useUserStore from '../../services/stores/UserStore';
import LoginSignupButtons from './account/LoginSignupButtons';
import If from '@components/misc/If';
import useApplicationStore from '@services/stores/ApplicationStore';
import AccountMenu from '@components/account/AccountMenu';
import AccountCompleteEmail from '@components/account/AccountCompleteEmail';
import { AccountEmailVerified } from '@components/account/AccountEmailVerified';
import NewportSociety from '@public/images/logo/newport-society.svg';

const styles = {
    loginButton: {
        ...theme.button.purchase,
        backgroundColor: theme.palette.primary.purchase.background,
        padding: '14px 12px',
        minWidth: 0,
        flexGrow: 0,
        fontSize: 10,
        textTransform: 'uppercase',
        '&:hover': {
            ...theme.button.purchaseHover,
        },
        '&:before': {
            content: '""',
            height: 1,
            backgroundColor: theme.palette.primary.background,
            display: 'block',
            position: 'absolute',
            top: 4,
            left: 0,
            right: 0,
            transition: 'all 0.25s ease',
        },
        '&:after': {
            content: '""',
            height: 1,
            backgroundColor: theme.palette.primary.background,
            display: 'block',
            position: 'absolute',
            bottom: 4,
            left: 0,
            right: 0,
            transition: 'all 0.25s ease',
        },
    },
    signupButton: {
        ...theme.button.purchase,
        backgroundColor: theme.palette.primary.purchase.background,
        padding: '14px 12px',
        minWidth: 0,
        flexGrow: 0,
        fontSize: 10,
        textTransform: 'uppercase',
        '&:hover': {
            ...theme.button.purchaseHover,
        },
        '&:before': {
            content: '""',
            height: 1,
            backgroundColor: theme.palette.primary.background,
            display: 'block',
            position: 'absolute',
            top: 4,
            left: 0,
            right: 0,
            transition: 'all 0.25s ease',
        },
        '&:after': {
            content: '""',
            height: 1,
            backgroundColor: theme.palette.primary.background,
            display: 'block',
            position: 'absolute',
            bottom: 4,
            left: 0,
            right: 0,
            transition: 'all 0.25s ease',
        },
    },
    loginWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    menuWrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        marginTop: 10,
    },
    menuButton: {
        justifyContent: 'flex-start',
        textTransform: 'inherit',
    },
    description: {
        marginBottom: '1rem',
    },
    trigger: {
        alignItems: 'flex-start',
        cursor: 'pointer',
        '& span': {
            marginRight: 10,
        }
    },
    alert: {
        display: 'grid',
        gridTemplateColumns: '1fr 160px',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 10,
        background: '#00000008',
    },
    signupWrapper: {
        padding: '2rem',
        background: '#041e3a',
        margin: -33,
        marginTop: 'auto',
        marginBottom: 0,
        paddingBottom: '8rem',
        color: 'white',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            marginLeft: -22,
            marginRight: -22,
        }
    },
    signup: {
        maxWidth: 400,
        margin: 'auto',
        marginTop: 50,
        width: '100%',
        '& > h3': {
            textAlign: 'center',
        }
    },
    icon: {
        [theme.breakpoints.down('md')]: {
            margin: '0 8px',
        },
    }
};

const useStyles = makeStyles(() => styles, { name: 'Account' });

export default function Account({anchor='right', label=''}) {
    const { toggleDrawer } = useApplicationStore((state) => state.methods);
    const open = useApplicationStore((state) => state.modals.accountDrawerOpen);
    const user = useUserStore();
    const classes = useStyles();
    const { t } = useTranslation([ 'account' ]);

    function toggle() {
        user.checkLoginStatus();
        toggleDrawer('accountDrawerOpen');
    }

    function renderNeedsEmail() {
        if (!user?.user?.needs_email) {
            return null;
        }

        return <AccountCompleteEmail></AccountCompleteEmail>;
    }

    function renderLoggedIn() {
        return <section className={classes.menuWrapper}>
            <AccountEmailVerified/>
            {renderNeedsEmail()}
            <AccountMenu/>
        </section>;
    }

    return <>
        <a onClick={() => toggle()} className={[ classes.trigger, 'myNewport' ].join(' ')}>
            <span>{label}</span> <AccountIcon width={20} className={classes.icon} />
        </a>
        <NewportDrawer anchor={anchor} open={open} close={() => toggle()}>
            <If condition={user.isLoggedIn}>
                <h3 className={classes.drawerTitle}>{t('account-login-drawer-title')}</h3>
                {renderLoggedIn()}
            </If>
            {!user.isLoggedIn ?
                <>
                    <LoginSignupButtons />
                    <section className={classes.signupWrapper}>
                        <section className={classes.signup}>
                            <NewportSociety style={{ maxWidth: 256, margin: '0 auto' }}></NewportSociety>
                            <p>{t('account-login-drawer-description')}</p>
                        </section>
                    </section>
                </>
                : null}

        </NewportDrawer>
    </>;
}
